import MDEditor from '@uiw/react-md-editor'
import React, { useEffect, useState } from 'react'
import { FieldHint, FieldLabel } from './TextInput'

const MarkdownInput = ({
  label,
  labelTopRight,
  labelBottomLeft,
  labelBottomRight,
  placeholder,
  name,
  required,
  defaultValue,
}) => {
  const [value, setValue] = useState('')

  useEffect(() => {
    if (defaultValue) {
      setValue(defaultValue)
    }
  }, [defaultValue])

  return (
    <div className="w-full" data-color-mode="light">
      <FieldLabel
        label={label}
        labelTopRight={labelTopRight}
        required={required}
      />
      <div className="rounded-xl border border-line overflow-hidden">
        <MDEditor
          textareaProps={{ name, placeholder }}
          value={value}
          onChange={setValue}
          commandsFilter={(command) => {
            if (command.name === 'checked-list') {
              return false
            }
            return command
          }}
        />
      </div>
      <FieldHint
        labelBottomLeft={labelBottomLeft}
        labelBottomRight={labelBottomRight}
      />
    </div>
  )
}

export default MarkdownInput
